import React from "react"
import ForHealthCoachHelpSectionStyle from "./ForHealthCoachHelpSectionStyle.module.styl"
import { Link } from "gatsby"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowRight } from "@fortawesome/free-solid-svg-icons/faArrowRight"
import Image from "gatsby-image"
import translate from "../../../../../translation/translator"
import keys from "../../../../../translation/keys"

const ForHealthCoachHelpSection = ({ healthCoachHelpImages, locale }) => {
  const image1 = healthCoachHelpImages[0].node.childImageSharp.fluid

  return (
    <div className={ForHealthCoachHelpSectionStyle.wrapper}>
      <div className={ForHealthCoachHelpSectionStyle.content}>
        <div className={ForHealthCoachHelpSectionStyle.image_holder}>
          <Image alt="help-image" fluid={image1} />
        </div>
        <div className={ForHealthCoachHelpSectionStyle.info_holder}>
          <h2 className={ForHealthCoachHelpSectionStyle.title}>
            {translate(keys.HLTH_COACH_HELP_HELP_PPL, locale)}
          </h2>
          <p className={ForHealthCoachHelpSectionStyle.description}>
            {translate(keys.HLTH_COACH_HELP_REACH_THE_WORLD, locale)}
          </p>
          <Link className={ForHealthCoachHelpSectionStyle.link} to="/">
            {translate(keys.HLTH_COACH_HELP_LEARN_MORE, locale)}{" "}
            <FontAwesomeIcon icon={faArrowRight} />
          </Link>
          <p className={ForHealthCoachHelpSectionStyle.sep} />
          <p className={ForHealthCoachHelpSectionStyle.info_text}>
            {translate(keys.HLTH_COACH_HELP_PROFIT, locale)}{" "}
          </p>
          <p className={ForHealthCoachHelpSectionStyle.author}>
            {translate(keys.HLTH_COACH_HELP_DR_HRISTO, locale)}{" "}
            <span>{translate(keys.HLTH_COACH_HELP_DOC, locale)}</span>
          </p>
        </div>
      </div>
    </div>
  )
}

export default ForHealthCoachHelpSection
